import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useMutationMemberInvoice({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: async ({ invoiceNumber }: { invoiceNumber: string }) => {
      return await api.memberApi.invoiceFile(invoiceNumber);
    },
  });
}
